import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';
import { filterNullishCriteria } from '../utils';

export type UseUpdateUrl = (
  data: object,
  options?: { replace?: boolean }
) => void;

export function useUpdateUrl(): UseUpdateUrl {
  const setSearchParams = useSearchParams()[1];

  const updateUrl = useCallback(
    (data: object, { replace = true }: { replace?: boolean } = {}) => {
      setSearchParams(
        filterNullishCriteria({
          ...data,
        }),
        { preventScrollReset: true, replace }
      );
    },
    [setSearchParams]
  );

  return updateUrl;
}

export default useUpdateUrl;
